// URL list
import URL from '../../../config.url'

import CoreResize from '../../mixins/core-resize'

import AppMenu from '../app-menu'
import AppMenuMatch from '../app-menu-match'
import AppBtnToggle from '../app-btn-toggle'

const HIDE_LABEL = 'header.matches.hide'

let store
try
{
    store = window.localStorage
}
catch (e)
{
    store = false
    console.warn('Please enable cookies to use all website features')
}


export default
{
    name: 'app-header',

    mixins:
    [
        CoreResize
    ],

    components:
    {
        AppMenu,
        AppMenuMatch,
        AppBtnToggle
    },

    props:
    {
        contentGlobal: { type: Object },
        contentPage: { type: Object }
    },

    data()
    {
        return {
            url: URL,
            hideScore: true,
            width: 0,
            matchDisplay: 0,
            matchesGameId: -1
        }
    },

    watch:
    {
        hideScore(hide)
        {
            if (store)
            {
                store.setItem(HIDE_LABEL, hide)
            }
        }
    },

    created()
    {
        for (const match of this.contentGlobal.headerMatches)
        {
            if (this.matchesGameId !== 0)
            {
                if (this.matchesGameId < 0)
                {
                    this.matchesGameId = match.videoGameId
                }
                else if (this.matchesGameId !== match.videoGameId)
                {
                    this.matchesGameId = 0
                }
            }
        }


        if (store)
        {
            this.hideScore = store.getItem(HIDE_LABEL) !== null ? store.getItem(HIDE_LABEL) == 'true' : true
        }
        else
        {
            this.hideScore = true
        }

        this.onResized()
    },

    methods:
    {
        onResized()
        {
            this.width = this.resize.width
            this.matchDisplay = Math.ceil((this.width - 660) / 200 - 1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-header/script.js